<app-create-sign [usingStraySettings]="true"></app-create-sign>
